class BundleBuilder {
  constructor() {
    this.products = window.bundleProducts;
    this.bundleType = 'coat-and-colour';
    this.selectedColor = null;
    this.selectedColors = [];
    this.selectedCoat = null;
    this.app = document.getElementById('bundle-builder-app');
    
    this.checkUrlParameters();
    this.init();
  }

  checkUrlParameters() {
    const urlParams = new URLSearchParams(window.location.search);
    const variantId = parseInt(urlParams.get('preselect')); 
    const productType = urlParams.get('type');
    
    console.log('Checking params:', { variantId, productType });

    if (variantId && productType) {
      if (productType === 'nail-polish') {
        const colorProduct = this.products.colours.find(p => p.id.toString() === variantId.toString());
        console.log('Found color:', colorProduct);
        
        if (colorProduct && colorProduct.available) {
          if (this.bundleType === 'coat-and-colour') {
            this.selectedColor = colorProduct;
          } else {
            this.selectedColors = [colorProduct];
          }
        }
      } else if (productType === 'coat') {
        const coatProduct = this.products.coats.find(p => p.id.toString() === variantId.toString());
        if (coatProduct && coatProduct.available) {
          this.selectedCoat = coatProduct;
        }
      }
    }
  }

  init() {
    if (!this.app) return;
    this.render();
    this.attachEventListeners();
  }

  getOriginalPrice(product, type) {
    return product.price;
  }

  getSortedProducts(products) {
    return [...products].sort((a, b) => {
      if (a.available === b.available) return 0;
      return a.available ? -1 : 1;
    });
  }

  calculateTotal() {
    if (this.bundleType === 'coat-and-colour') {
      if (this.selectedColor && this.selectedCoat) {
        const originalTotal = parseFloat(this.selectedColor.price) + parseFloat(this.selectedCoat.price);
        const discountedTotal = Math.round(originalTotal * 0.886);
        return {
          original: originalTotal.toFixed(2),
          discounted: discountedTotal.toFixed(2)
        };
      }
      return { original: '0.00', discounted: '0.00' };
    } else {
      if (this.selectedColors.length && this.selectedCoat) {
        const originalTotal = this.selectedColors.reduce((sum, color) => sum + parseFloat(color.price), 0) + parseFloat(this.selectedCoat.price);
        const discountedTotal = Math.round(originalTotal * 0.833);
        return {
          original: originalTotal.toFixed(2),
          discounted: discountedTotal.toFixed(2)
        };
      }
      return { original: '0.00', discounted: '0.00' };
    }
  }

  hasPreorderItem() {
    const hasPreorderColor = this.bundleType === 'coat-and-colour' 
      ? (this.selectedColor && this.selectedColor.tags && this.selectedColor.tags.includes('pre-order'))
      : this.selectedColors.some(color => color.tags && color.tags.includes('pre-order'));
    
    const hasPreorderCoat = this.selectedCoat && this.selectedCoat.tags && this.selectedCoat.tags.includes('pre-order');
    
    return hasPreorderColor || hasPreorderCoat;
  }

  renderProductCard(product, type) {
    const isSelected = this.isProductSelected(product, type);
    const isSelectable = this.isProductSelectable(product, type);
    const isSoldOut = !product.available;
    const isPreorder = product.tags && product.tags.includes('pre-order');
    
    return `
      <div class="product-card ${!isSelectable || isSoldOut ? 'disabled' : ''} ${isSelected ? 'selected' : ''} ${isSoldOut ? 'sold-out' : ''}">
        <div class="product-image-container">
          <img 
            src="${product.image}" 
            alt="${product.title}"
            class="product-image"
          />
        </div>
        <div class="product-info">
          <h3>${product.title}</h3>
          <div class="price-container">
            <span class="original-price">$${this.getOriginalPrice(product, type)}</span>
          </div>
          <div class="button-group">
            <button 
              class="select-button ${isSelected ? 'selected' : ''} ${isSoldOut ? 'sold-out' : ''}"
              data-product-id="${product.id}"
              data-product-type="${type}"
              ${!isSelectable || isSoldOut ? 'disabled' : ''}
            >
              ${this.getButtonText(product, type)}
            </button>
            ${isSelected ? `
              <button 
                class="remove-button"
                data-product-id="${product.id}"
                data-product-type="${type}"
              >
                <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2">
                  <line x1="18" y1="6" x2="6" y2="18"></line>
                  <line x1="6" y1="6" x2="18" y2="18"></line>
                </svg>
              </button>
            ` : ''}
          </div>
        </div>
      </div>
    `;
  }

  render() {
    const totals = this.calculateTotal();
    
    this.app.innerHTML = `
      <div class="page-width bundle-layout">
        <div class="bundle-main">
          <div class="bundle-type-selector">
            <h1 class="bundle-title">Choose Your Bundle</h1>
            <div class="bundle-options">
              <button 
                class="bundle-option ${this.bundleType === 'coat-and-colour' ? 'selected' : ''}"
                data-bundle-type="coat-and-colour"
              >
                <div class="bundle-option-title">Coat + Colour</div>
                <div class="bundle-option-description">Select one colour and one coat</div>
              </button>
              <button 
                class="bundle-option ${this.bundleType === 'pick-two' ? 'selected' : ''}"
                data-bundle-type="pick-two"
              >
                <div class="bundle-option-title">Pick 2 & Get A Coat Half Price</div>
                <div class="bundle-option-description">Pick any two colours and get a coat at 50% off</div>
              </button>
            </div>
          </div>

          <div class="product-section">
            <h2 class="section-title">
              Step 1: ${this.bundleType === 'coat-and-colour' ? 'Pick Your Colour' : 'Pick Your Colours'}
              ${this.bundleType === 'pick-two' ? 
                `<span class="remaining-count">(${2 - this.selectedColors.length} remaining)</span>` : 
                ''}
            </h2>
            <div class="product-grid">
              ${this.getSortedProducts(this.products.colours).map(product => this.renderProductCard(product, 'colour')).join('')}
            </div>
          </div>

          <div class="product-section">
            <h2 class="section-title">
              Step 2: Pick Your ${this.bundleType === 'pick-two' ? 'Half Price ' : ''}Coat
            </h2>
            <div class="product-grid">
              ${this.getSortedProducts(this.products.coats).map(product => this.renderProductCard(product, 'coat')).join('')}
            </div>
          </div>
        </div>

        <div class="bundle-summary">
          <div class="bundle-summary-content">
            <h2 class="summary-title">Your Bundle</h2>
            <div class="selected-items">
              ${this.bundleType === 'coat-and-colour' ? `
                ${this.selectedColor ? `
                  <div class="summary-item">
                    <span>Colour:</span>
                    <div class="summary-item-content">
                      <div class="color-circle" style="background-color: ${this.selectedColor.colorHex || '#000000'}"></div>
                      <span>${this.selectedColor.title} ${this.selectedColor.tags && this.selectedColor.tags.includes('pre-order') ? '<span class="pre-order-tag">Pre-order</span>' : ''}</span>
                    </div>
                  </div>
                ` : ''}
              ` : `
                ${this.selectedColors.map((color, index) => `
                  <div class="summary-item">
                    <span>Colour ${index + 1}:</span>
                    <div class="summary-item-content">
                      <div class="color-circle" style="background-color: ${color.colorHex || '#000000'}"></div>
                      <span>${color.title} ${color.tags && color.tags.includes('pre-order') ? '<span class="pre-order-tag">Pre-order</span>' : ''}</span>
                    </div>
                  </div>
                `).join('')}
              `}
              ${this.selectedCoat ? `
                <div class="summary-item">
                  <span>Coat:</span>
                  <span>${this.selectedCoat.title} ${this.selectedCoat.tags && this.selectedCoat.tags.includes('pre-order') ? '<span class="pre-order-tag">Pre-order</span>' : ''}</span>
                </div>
              ` : ''}
            </div>
            <div class="bundle-total">
              <span>Total:</span>
              <div class="bundle-total-prices">
                <span class="bundle-total-original">$${totals.original}</span>
                <span class="bundle-total-final">$${totals.discounted}</span>
              </div>
            </div>
            <button 
              class="add-to-cart-button"
              ${!this.isBundleComplete() ? 'disabled' : ''}
            >
              Add to Cart
            </button>
            ${this.hasPreorderItem() ? `
              <div class="pre-order-notice">
                <p>Your bundle contains pre-order item(s). Your entire bundle will ship when all items are available.</p>
              </div>
            ` : ''}
          </div>
        </div>
      </div>
    `;
  }

  isProductSelected(product, type) {
    if (type === 'colour') {
      if (this.bundleType === 'coat-and-colour') {
        return this.selectedColor?.id === product.id;
      } else {
        return this.selectedColors.some(color => color.id === product.id);
      }
    } else {
      return this.selectedCoat?.id === product.id;
    }
  }

  isProductSelectable(product, type) {
    if (!product.available) {
      return false;
    }

    if (type === 'colour') {
      if (this.bundleType === 'coat-and-colour') {
        return !this.selectedColor || this.selectedColor.id === product.id;
      } else {
        return this.selectedColors.length < 2 || this.selectedColors.some(color => color.id === product.id);
      }
    } else {
      return !this.selectedCoat || this.selectedCoat.id === product.id;
    }
  }

  getButtonText(product, type) {
    const isSelected = this.isProductSelected(product, type);
    const isSoldOut = !product.available;
    const isPreorder = product.tags && product.tags.includes('pre-order');
    
    if (isSoldOut) return 'SOLD OUT';
    if (isSelected) return 'SELECTED';
    if (!this.isProductSelectable(product, type)) {
      return type === 'colour' ? 
        (this.bundleType === 'coat-and-colour' ? 'PICK ONLY ONE' : 'MAX TWO COLORS') : 
        'SELECT COAT';
    }
    return isPreorder ? `PRE-ORDER` : `SELECT ${type.toUpperCase()}`;
  }

  isBundleComplete() {
    if (this.bundleType === 'coat-and-colour') {
      return this.selectedColor && this.selectedCoat;
    } else {
      return this.selectedColors.length === 2 && this.selectedCoat;
    }
  }

  attachEventListeners() {
    this.app.addEventListener('click', (e) => {
      const bundleOption = e.target.closest('.bundle-option');
      const selectButton = e.target.closest('.select-button');
      const removeButton = e.target.closest('.remove-button');
      const addToCartButton = e.target.closest('.add-to-cart-button');

      if (bundleOption) {
        const type = bundleOption.dataset.bundleType;
        const previousType = this.bundleType;
        this.bundleType = type;
        
        if (previousType === 'coat-and-colour' && type === 'pick-two') {
          if (this.selectedColor) {
            this.selectedColors = [this.selectedColor];
          }
          this.selectedColor = null;
        }
        else if (previousType === 'pick-two' && type === 'coat-and-colour') {
          if (this.selectedColors.length > 0) {
            this.selectedColor = this.selectedColors[0];
          }
          this.selectedColors = [];
        }
        
        this.render();
      }

      if (selectButton && !selectButton.disabled) {
        const productId = parseInt(selectButton.dataset.productId);
        const productType = selectButton.dataset.productType;
        const product = this.products[productType === 'colour' ? 'colours' : 'coats'].find(p => p.id === productId);

        if (!product.available) {
          return;
        }

        if (productType === 'colour') {
          if (this.bundleType === 'coat-and-colour') {
            this.selectedColor = this.selectedColor?.id === productId ? null : product;
          } else if (this.selectedColors.length < 2) {
            this.selectedColors = [...this.selectedColors, product];
          }
        } else {
          this.selectedCoat = this.selectedCoat?.id === productId ? null : product;
        }
        this.render();
      }

      if (removeButton) {
        const productId = parseInt(removeButton.dataset.productId);
        const productType = removeButton.dataset.productType;
        
        if (productType === 'colour') {
          if (this.bundleType === 'coat-and-colour') {
            this.selectedColor = null;
          } else {
            this.selectedColors = this.selectedColors.filter(color => color.id !== productId);
          }
        } else {
          this.selectedCoat = null;
        }
        this.render();
      }

      if (addToCartButton && !addToCartButton.disabled && this.isBundleComplete()) {
        this.addToCart();
      }
    });
  }

  addToCart() {
    const button = this.app.querySelector('.add-to-cart-button');
    button.disabled = true;
    button.textContent = 'Adding...';

    const formData = {
      items: []
    };

    if (this.bundleType === 'coat-and-colour') {
      const colorProperties = {
        '_bundle_type': 'Coat + Colour Bundle'
      };
      
      if (this.selectedColor.tags && this.selectedColor.tags.includes('pre-order')) {
        colorProperties['Pre-order'] = 'This is a pre-order item that will ship when available';
      }
      
      const coatProperties = {
        '_bundle_type': 'Coat + Colour Bundle'
      };
      
      if (this.selectedCoat.tags && this.selectedCoat.tags.includes('pre-order')) {
        coatProperties['Pre-order'] = 'This is a pre-order item that will ship when available';
      }
      
      formData.items = [
        {
          id: parseInt(this.selectedColor.id),
          quantity: 1,
          properties: colorProperties
        },
        {
          id: parseInt(this.selectedCoat.id),
          quantity: 1,
          properties: coatProperties
        }
      ];
    } else {
      this.selectedColors.forEach(color => {
        const properties = {
          '_bundle_type': 'Pick 2 Bundle'
        };
        
        if (color.tags && color.tags.includes('pre-order')) {
          properties['Pre-order'] = 'This is a pre-order item that will ship when available';
        }
        
        formData.items.push({
          id: parseInt(color.id),
          quantity: 1,
          properties: properties
        });
      });

      const coatProperties = {
        '_bundle_type': 'Pick 2 Bundle',
        '_half_price': 'true'
      };
      
      if (this.selectedCoat.tags && this.selectedCoat.tags.includes('pre-order')) {
        coatProperties['Pre-order'] = 'This is a pre-order item that will ship when available';
      }
      
      formData.items.push({
        id: parseInt(this.selectedCoat.id),
        quantity: 1,
        properties: coatProperties
      });
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData)
    })
    .then(response => response.json())
    .then(() => {
      fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
          button.disabled = false;
          button.textContent = 'Add to Cart';

          const cartDrawer = document.querySelector('cart-drawer');
          if (cartDrawer) {
            fetch('/?section_id=cart-drawer')
              .then(response => response.text())
              .then(text => {
                const html = new DOMParser()
                  .parseFromString(text, 'text/html')
                  .querySelector('cart-drawer')
                  .innerHTML;
                
                document.querySelector('cart-drawer').innerHTML = html;
                cartDrawer.classList.remove('is-empty');
                cartDrawer.classList.add('active');
              });
          }
        });
    })
    .catch(() => {
      button.disabled = false;
      button.textContent = 'Add to Cart';
      alert('Error adding items to cart. Please try again.');
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  try {
    new BundleBuilder();
  } catch (error) {
    console.error('Bundle Builder Error:', error);
    const app = document.getElementById('bundle-builder-app');
    if (app) {
      app.innerHTML = `<div class="error-message">There was an error loading the bundle builder. Please refresh the page or contact support.</div>`;
    }
  }
});


